export const iconFontAwesomeScienceSyringe = (
	<i className="fa-solid fa-syringe"></i>
);
